import { Link as MuiLink, Theme, withStyles } from "@material-ui/core";
import React from "react";
import { Link as RouterLink, NavLink as RouterNavLink } from "react-router-dom";

const styles = (theme: Theme) => ({
    root: {
        "&:hover": {
            color: theme.palette.text.primary,
            textDecoration: "none",
        },
    },
});

export const Link = withStyles(styles)(function (props: any) {
    const { children, classes, ...extraProps } = props;
    return (
        <MuiLink component={RouterLink} className={classes.root} {...extraProps}>
            {children}
        </MuiLink>
    );
});

export const NavLink = withStyles(styles)(function (props: any) {
    const { children, classes, ...extraProps } = props;
    return (
        <MuiLink component={RouterNavLink} className={classes.root} {...extraProps}>
            {children}
        </MuiLink>
    );
});
